@let nde = $nde();
@if(nde.lastNdeDate) {

<mat-chip-set role="list" aria-label="NDE Dates">
  <mat-chip role="listitem">
    {{nde.lastNdeDate | date: 'shortDate'}}
  </mat-chip>

  <mat-chip role="listitem" [class.two-weeks-out]="nde.inspectionLessThan2Weeks"
    [class.expired]="nde.isExpried">
    {{nde.sixMonthInspectionDate | date: 'shortDate'}}
  </mat-chip>
</mat-chip-set>
}
